export default {
  EM_ANDAMENTO: 'EM_ANDAMENTO',
  AGUARDANDO_ENVIO_CARTORIO: 'AGUARDANDO_ENVIO_CARTORIO',
  AGUARDANDO_VALIDACAO: 'AGUARDANDO_VALIDACAO',
  VALIDADO: 'VALIDADO',
  AGUARDANDO_RESPOSTA_DO_CARTORIO: 'AGUARDANDO_RESPOSTA_CARTORIO',
  FINALIZADO: 'FINALIZADO',
  AGUARDANDO_RESPOSTA_SICARF: 'AGUARDANDO_RESPOSTA_SICARF'
}



// WEBPACK FOOTER //
// ./src/constants/statusOficioArrecadacao.js